export const data = {
    experience: [
        {
            title: "Student",
            subTitle: "Online",
            description: "Certificates for completing courses on Udemy in Web development"
        },
    ],

    education: [
        {
            title: "Incomplete secondary",
            subTitle: "Secondary school of grades I-III",
            description: "9th Grade"
        },

        {
            title: "Full secondary",
            subTitle: "Technical Professional College",
            description: "12th Grade"
        },

        {
            title: "Professional Junior Bachelor",
            subTitle: "Technical Professional College",
            description: "Automation and computer-integrated technologies"
        }
    ]
};